import type { SVGProps } from "react"

export const SvgNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width="40"
    height="40"
    {...props}
  >
    <path
      fill="currentColor"
      d="M42.3 24 45.7 18.9a2 2 0 0 0 .2-1.7 1.8 1.8 0 0 0-1.2-1.2l-5.9-2.4-.5-5.9a2.1 2.1 0 0 0-.7-1.5 2 2 0 0 0-1.7-.3l-6.3 1.3-4.1-4.6a2.2 2.2 0 0 0-3 0l-4.1 4.6-6.3-1.3a2 2 0 0 0-1.7.3 2.1 2.1 0 0 0-.7 1.5l-.5 5.9L3.3 16a1.8 1.8 0 0 0-1.2 1.2 2 2 0 0 0 .2 1.7L5.7 24l-3.4 5.1a2 2 0 0 0 1 2.9l5.9 2.4.5 5.9a2.1 2.1 0 0 0 .7 1.5 2 2 0 0 0 1.7.3l6.3-1.3 4.1 4.5a2 2 0 0 0 3 0l4.1-4.5 6.3 1.3a2 2 0 0 0 1.7-.3 2.1 2.1 0 0 0 .7-1.5l.5-5.9 5.9-2.4a2 2 0 0 0 1-2.9Z"
    />
    <text
      x="50%"
      y="58%"
      textAnchor="middle"
      fill="white"
      fontSize="12"
      fontWeight="bold"
      fontFamily="Arial, sans-serif"
    >
      NEW
    </text>
  </svg>
)
